import { render } from "./CategoryBoxesComp.vue?vue&type=template&id=3ac62c84&scoped=true&ts=true"
import script from "./CategoryBoxesComp.vue?vue&type=script&lang=ts"
export * from "./CategoryBoxesComp.vue?vue&type=script&lang=ts"

import "./CategoryBoxesComp.vue?vue&type=style&index=0&id=3ac62c84&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac62c84"]])

export default __exports__